export default {
  Title: 'Προσφορές | Προσφορά | Προσφορές',

  OnePlusOne: '💥1+1💥'
}
